<template>
  <Teleport to="#modal">
    <CModal
      content-class-name="align-items-center bg-white p-4 shadow-none border-0"
      :visible="props.visible"
      alignment="center"
    >
      <i class="fa fa-exclamation-triangle fa-5x fa-fw text-danger"></i>
      <h3>An error has occured</h3>
    </CModal>
  </Teleport>
</template>
<script lang="ts" setup>
import { CModalHeader } from "@coreui/vue-pro";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});
</script>
<style lang=""></style>
